import React from "react";
import { Link } from "react-router-dom";
import "./AmazoniaDiplomatica.css";
import AmazoniaDiplomaticaFormulario from "./AmazoniaDiplomaticaFormulario";

const cronograma = [
  ["06 a 13/11", "Inscrições"],
  ["16/11", "Divulgação do resultado"],
  ["18/11", "Formação da Imprensa"],
  ["19/11", "Formação da Mesa Diretora"],
  ["20/11", "Reunião preparatória"],
  ["21/11", "Conferência Simulada"],
];

const modalidades = [
  {
    numero: "01",
    titulo: "Delegações",
    vagas: "20 estudantes",
    descricao:
      "Participação em duplas, com indicação de Delegado Oficial e Delegado Suplente. A seleção prevê 10 titulares e 10 suplentes.",
  },
  {
    numero: "02",
    titulo: "Mesa Diretora",
    vagas: "4 estudantes",
    descricao:
      "Atuação na condução das sessões, organização dos debates e acompanhamento dos procedimentos dos comitês.",
  },
  {
    numero: "03",
    titulo: "Imprensa",
    vagas: "4 estudantes",
    descricao:
      "Cobertura das atividades, produção de conteúdos e registro dos principais acontecimentos da conferência.",
  },
];

export default function AmazoniaDiplomatica() {
  return (
    <main className="ad-page">
      <section className="ad-hero">
        <div className="ad-container ad-hero-content">
          <div className="ad-eyebrow">
            INSTITUTO IMA • MERCOSUL 2026
          </div>

          <h1>
            AMAZÔNIA
            <br />
            <span>DIPLOMÁTICA</span>
          </h1>

          <p className="ad-subtitle">
            Conferência Simulada da ONU
          </p>

          <p className="ad-description">
            Soluções inovadoras para desafios reais.
            Uma experiência de diplomacia, protagonismo
            estudantil e cooperação internacional.
          </p>

          <div className="ad-hero-info">
            <span>21 DE NOVEMBRO DE 2026</span>
            <span>08H ÀS 18H</span>
            <span>HUB ACRE • RIO BRANCO</span>
          </div>

          <div className="ad-actions">
            <a href="#inscricoes" className="ad-button ad-button-primary">
              Quero participar
            </a>

            <a href="#sobre" className="ad-button ad-button-outline">
              Conheça o evento
            </a>
          </div>
        </div>
      </section>

      <section id="sobre" className="ad-section">
        <div className="ad-container ad-about">
          <div>
            <span className="ad-label">SOBRE A CONFERÊNCIA</span>

            <h2>
              A diplomacia começa
              <br />
              com novas perspectivas.
            </h2>
          </div>

          <div>
            <p>
              A Amazônia Diplomática é uma conferência
              simulada que aproxima estudantes do Ensino
              Médio dos debates internacionais e dos
              processos de negociação diplomática.
            </p>

            <p>
              Durante o evento, participantes representarão
              países, conduzirão debates e produzirão
              conteúdos sobre desafios econômicos,
              sociais e climáticos.
            </p>
          </div>
        </div>
      </section>

      <section className="ad-section ad-section-dark">
        <div className="ad-container">
          <span className="ad-label">TEMAS EM DEBATE</span>

          <h2>Dois comitês. Grandes desafios.</h2>

          <div className="ad-grid ad-grid-two">
            <article className="ad-topic-card">
              <span>COMITÊ 01</span>
              <h3>
                Conselho do Mercado Comum
                <br />
                MERCOSUL
              </h3>
              <p>
                A influência econômica dos Estados Unidos
                e da China e as escolhas estratégicas
                para o MERCOSUL.
              </p>
            </article>

            <article className="ad-topic-card">
              <span>COMITÊ 02</span>
              <h3>
                Assuntos Sociais
                <br />
                e Climáticos
              </h3>
              <p>
                Povos indígenas, mudanças climáticas
                e o protagonismo das lideranças indígenas
                nas decisões sobre o futuro.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section className="ad-section">
        <div className="ad-container">
          <span className="ad-label">FORMAS DE PARTICIPAÇÃO</span>

          <h2>Escolha seu papel na conferência.</h2>

          <div className="ad-grid ad-grid-three">
            {modalidades.map((item) => (
              <article className="ad-role-card" key={item.numero}>
                <span className="ad-role-number">{item.numero}</span>
                <h3>{item.titulo}</h3>
                <strong>{item.vagas}</strong>
                <p>{item.descricao}</p>
              </article>
            ))}
          </div>

          <p className="ad-note">
            São 28 vagas para estudantes do Ensino Médio
            de escolas públicas e privadas do Acre.
            As inscrições são gratuitas e estão sujeitas
            aos critérios do edital.
          </p>
        </div>
      </section>

      <section className="ad-section ad-section-muted">
        <div className="ad-container">
          <span className="ad-label">DATAS IMPORTANTES</span>
          <h2>Fique de olho no cronograma.</h2>

          <div className="ad-timeline">
            {cronograma.map(([data, descricao]) => (
              <div className="ad-timeline-item" key={data}>
                <strong>{data}</strong>
                <span>{descricao}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="inscricoes" className="ad-section ad-section-muted">
        <div className="ad-container">
          <AmazoniaDiplomaticaFormulario />
        </div>
      </section>

      <footer className="ad-footer">
        <div className="ad-container">
          <strong>AMAZÔNIA DIPLOMÁTICA</strong>
          <span>Conferência Simulada • MERCOSUL 2026</span>
          <Link to="/">Voltar ao Instituto IMA</Link>
        </div>
      </footer>
    </main>
  );
}
